import getall from './getall';
import getlist from './getlist';
import getsplists from './getsplists';
import getlistentries from './getlistentries';
import lookupurl from './lookupurl';
import lookupspurl from './lookupspurl';
import putbulklist from './putbulklist';
import editlistentry from './editlistentry';
import dellistentry from './dellistentry';

export default {
  getall,
  getsplists,
  getlist,
  getlistentries,
  lookupurl,
  lookupspurl,
  putbulklist,
  editlistentry,
  dellistentry,
};



// WEBPACK FOOTER //
// ./src/app/services/list/index.js